export enum LifecycleStatus {
    OutOfSeason = '25 - UTE AV SESONG',
}